<div class="login-container">
  <div class="row g-0">

    <div class="col-md-6 left-side">
      <!-- Left Side -->
      <app-login-image></app-login-image>
    </div>

    <div class="col-md-6 right-side text-center">
      <!-- Right Side - Login Form -->
      <div class="login-form">
        <h1 class="error-code text-center">403</h1>
        <h2 class="error-title">Unauthorized Access</h2>
        <p class="error-description">You do not have permission to view this page. Please contact your administrator or
          log in with the appropriate credentials.</p>
        <div class="action-buttons">
          <a (click)="goToLogin()" class="btn-login">Go to Login</a>
          <a (click)="goBack()" class="btn-back">Go Back</a>
        </div>
      </div>
    </div>
  </div>
</div>